module.exports = __webpack_public_path__ + "static/media/smiley.9f22f2f9.svg";